import api from '@/api/api.js'
import api_config from '@/api/config/_api_config'

export default {
    initialiserTarifManquant(data) {
        return api.clinique().post('/tarifs-consultations/initialiser-manquant', data).then(response => response.data)
    },
    getReattributionAccess(data) {
        return api_config().post('/consultations/reattribution-access', data,
            { med005_access_request: true }).then(response => response.data)
    },
    getConsultationsReattribuables(data, access_token) {
        return api.clinique().post('/consultations/reattribution/liste', data,
            { headers: { 'X-Reattribution-Access': access_token }, med005_scoped_access: true }).then(response => response.data)
    },
    reattribuerConsultation(consultation_id, data, access_token) {
        return api.clinique().post('/consultations/reattribution/'+consultation_id, data,
            { headers: { 'X-Reattribution-Access': access_token }, med005_scoped_access: true }).then(response => response.data)
    },
    proposerMedecin(data) {
        return api.clinique().post('/consultations/proposition-medecin', data).then(response => response.data)
    },
    confirmerMedecin(data) {
        return api.clinique().post('/consultations/confirmer-medecin', data).then(response => response.data)
    },
    libererMedecin(token) {
        return api.clinique().delete('/consultations/reservation-medecin', { data: { reservation_token: token } }).then(response => response.data)
    },
    getMedecinsEligibles(typeId) {
        return api.clinique().get('/consultations/medecins-eligibles', { params: { type_consultation_id: typeId } }).then(response => response.data)
    },
    getMedecinsSansAcces(typeId) {
        return api.clinique().get('/consultations/medecins-sans-acces', { params: { type_consultation_id: typeId } }).then(response => response.data)
    },
    accorderAccesMedecin(data) {
        return api.clinique().post('/consultations/accorder-acces-medecin', data).then(response => response.data)
    },
    getCompteurConsultations() {
        const promise = api.clinique().get('/consultations/stat-counter')
        return promise.then(response => response.data)
    },

    getMomentsConsultations() {
        const promise = api.clinique().get('/moments_consultations')
        return promise.then(response => response.data)
    },
    getTypeConsultation() {
        const promise = api.clinique().get('/types_consultations')
        return promise.then((response) => response.data)
    },
    getTypesConsultations() {
        const promise = api.clinique().get('/types_consultations')
        return promise.then((response) => response.data)
    },

    getTarifConsultation(data) {
        const promise = api.clinique().post('/tarif-consultations/show', data)
        return promise.then((response) => response.data)
    },

    getTypesForConsultation(idConsult) {
        const promise = api.clinique().get(`/consultations/${idConsult}/getTypes`)
        return promise.then((response) => response.data)
    },
    getAllConsultation() {
        const promise = api.clinique().get(`/consultations/all`)
        return promise.then((response) => response.data)
    },

    getAllFactures() {
        const promise = api.clinique().get(`/consultations/factures/all`)
        return promise.then((response) => response.data)
    },


    getPrixCarnet() {
        const promise = api.clinique().get(`/prix_carnet`)
        return promise.then((response) => response.data)
    },

    geDureeBonConsultation() {
        const promise = api.clinique().get(`/duree_bon_consultation`)
        return promise.then((response) => response.data)
    },

    getLastConsultationByPatientEtType(idPatient, idTypeConsultation) {
        const promise = api.clinique().get(`/consultations/patients/${idPatient}/type/${idTypeConsultation}/latest`)
        return promise.then((response) => response.data)
    },

    getLastConsultationCpnByPatient(idPatient, idTypeConsultation) {
        const promise = api.clinique().get(`/consultations_cpn/patients/${idPatient}/type/${idTypeConsultation}/latest`)
        return promise.then((response) => response.data)
    },

    // -------------------- STATS CONSULTATION  -------------------
    /**
     * Nombre de consultation en attente
     * @returns 
     */  
    getConsultationAttente() {
        const promise = api.clinique().get('/consultation-attente/count')
        return promise.then((response) => response.data)
    },

    getCountTodayConsultations() {
        const promise = api.clinique().get('/consultations/count_today')
        return promise.then((response) => response.data)
    },

    getCountMonthConsultations(month) {
        const promise = api.clinique().get('/consultations/count_month?month=' + month)
        return promise.then((response) => response.data)
    },
    // ----------   FIN STATS CONSULTATTION     --------------------

    // PRESCRIPTIONS PHARMACIE
    getPrescriptionsPharmacie(idConsult, bought) {
        const promise = api.clinique().get(`/consultations/${idConsult}/prescriptions/pharmacie/${bought}`)
        return promise.then((response) => response.data)
    },
    sendPrescriptionsAfterVente(data) {
        const promise = api.clinique().post('/prescriptions/update_after_vente', data)
        return promise.then(response => response.data)
    },

    getDureeValiditeConsultation(data) {
        const promise = api.clinique().post('/consultations/duree_validite', data)
        return promise.then(response => response.data)
    },

    getListeFiliation(data) {
        const promise = api.clinique().get('/champs/type_champs/'+data.data_type+'/liste_data')
        return promise.then(response => response.data)
    },

    getConsommableBonForTypeConsultation(type_consultation_id) {
        const promise = api.clinique().get('/config/type_consultation/'+type_consultation_id+'/bon_consommable')
        return promise.then(response => response.data)
    },

    validatePendingConsultation(data) {
        const promise = api.clinique().post('/consultation-attente/payer', data)
        return promise.then(response => response.data)
    },

    checkIfPatientHasOnGoingTypeConsultation(data) {
        const promise = api.clinique().post('/consultations/check-ongoing-type-consultation', data)
        return promise.then(response => response.data)
    },

    getDifferentialComputing() {
        const promise = api.clinique().get('/consultations/calcul-differentiel')
        return promise.then(response => response.data)
    },

    storeBonConsultation(data) {
        const promise = api.clinique().post('/consultation/generer-bon', data)
        return promise.then((response) => response.data)
    },

    getListeConsultations(data) {
        const promise = api.clinique().post('/consultations/tous', data)
        return promise.then((response) => response.data)
    },

    getListeRDV() {
        const promise = api.clinique().get('/rdv/liste/prochain-rdv')
        return promise.then((response) => response.data)
    },

    getListBonConsultations(data) {
        const promise = api.clinique().post('/consultations/liste-bons', data)
        return promise.then((response) => response.data)
    },

    getLatestPatientNumBonSociete(data) {
        const promise = api.clinique().post('/consultations/patient/latest/numero-bon-societe', data)
        return promise.then((response) => response.data)
    },
}
